import React, { useState, useEffect, useRef } from "react";
import { getField, getTable } from "../../../Services/tooltipService";
import _ from "lodash";
import ToastElement from "../../../Components/UiComponents/ToastElement";
import Loader from "../../../Components/UiComponents/Loader";
import DropdownElement from "../../../Components/UiComponents/DropdownElement";
import { getByYear, saveUpdate } from "../../../Services/targetService";
import ButtonElement from "../../../Components/UiComponents/ButtonElement";
import { get } from "../../../Services/customerServices";
import InputTextElementElement from "../../../Components/UiComponents/InputTextElement";
import CheckboxElement from "../../../Components/UiComponents/CheckboxElement";
import { useBaseline } from "../../../Providers/BaselineContext";
import { useNavigate } from "react-router-dom";
import PlaylistVideos from '../../../Components/Videos/PlaylistVideos';
import { Dialog } from 'primereact/dialog';

const Baseline = () => {
    const [targetPlanFieldsNew, setTargetPlanFieldsNew] = useState([]);
    const [loading, setLoading] = useState(false);
    const [years, setYears] = useState([{ label: '2012', year: 2012 }]);
    const [targetData, setTargetData] = useState([]);
    const [totalValue, setTotalValue] = useState(0);
    const [headerFName, setHeaderFName] = useState('Forecast');
    const [targetTable, setTargetTable] = useState([]);
    const [targetHeaders, setTargetHeaders] = useState([]);
    const [months, setMonths] = useState([]);
    const [logFrameGoal, setLogFrameGoal] = useState([]);
    const [unitofMeasurement, setUnitofMeasurement] = useState([]);
    const [referenceData, setReferenceData] = useState([]);
    const [checkDups, setCheckDups] = useState({});
    const [colTotals, setColTotals] = useState(new Array(9).fill(0));
    const [totalSales, setTotalSales] = useState(0);
    const [loadRefresh, setLoadRefresh] = useState(false);
    const [showVideo, setShowVideo] = useState(false);
    const navigate = useNavigate()
    const { globalBaselineData, setGlobalBaselineData } = useBaseline();

    const toastRef = useRef();
    var enduser = localStorage.getItem("enduser")
	if (enduser) {
		var tmpData = JSON.parse(enduser);
		if (tmpData === null) {
            navigate("/login")
            localStorage.clear()
        }
	}

    var currentDate = new Date();
    var yearDate = new Date(currentDate).getFullYear();
    const [currentYear, setCurrentYear] = useState({ label: yearDate.toString(), year: yearDate });

    useEffect(() => {
        initialgetFields()
        yearInc((yearDate - years[0].year) + 7)
        loadByYear(yearDate)
        initialgetTables()
        dynamicMonths()
    }, [])

    useEffect(() => {
        if (checkDups.field) {
            checkForDups(checkDups.index)
        }
    }, [checkDups])

    useEffect(() => {
        updateTotals();
    }, [targetData]);

    useEffect(() => {
        if (loadRefresh && targetData) {
            loadAndSaving(targetData);
        }
    }, [loadRefresh, targetData])

    useEffect(() => {
        if (targetData && currentYear) {
            var targetDetails = {};
            targetDetails.year = currentYear.year;
            targetDetails.customer_id = tmpData.customer;
            targetDetails.impact_target = targetData;
            targetDetails.total = totalValue;
            setGlobalBaselineData(targetDetails)
        }
    }, [targetData, currentYear]);

    const getColumnTotal = (selector) => {
        let total = 0;
        targetData.forEach(item => {
            if (selector >= 1 && selector <= 12 && item.logFrame) {
                total += parseFloat(item.logFrame[`month${selector}`] || 0);
            }
        });
        return total;
    };

    const updateTotals = () => {
        const updatedColTotals = new Array(9).fill(0);
        for (let i = 1; i <= 12; i++) {
            updatedColTotals[i] = getColumnTotal(i);
        }
        setColTotals(updatedColTotals);
        setTotalSales(updatedColTotals.slice(1, 13).reduce((acc, val) => acc + val, 0).toFixed(2));
    };

    const checkForDups = (index) => {
        var updatedTargetData = [...targetData]
        var record = updatedTargetData[index];
        var firstIndex = _.findIndex(updatedTargetData, { logFrameGoal: record.logFrameGoal, logFrameTarget: record.logFrameTarget, logFrameIndicator: record.logFrameIndicator, logFrameSubIndicator: record.logFrameSubIndicator });
        var lastIndex = _.findLastIndex(updatedTargetData, { logFrameGoal: record.logFrameGoal, logFrameTarget: record.logFrameTarget, logFrameIndicator: record.logFrameIndicator, logFrameSubIndicator: record.logFrameSubIndicator });
        if (firstIndex != lastIndex) {
            if (record.logFrameGoal == record.logFrameGoal && record.logFrameTarget == record.logFrameTarget && record.logFrameIndicator == record.logFrameIndicator && record.logFrameSubIndicator == record.logFrameSubIndicator) {
                updatedTargetData[index].logFrameSubIndicator = '';
            }
            toastRef.current.showToast({
                type: 'error',
                message: "Duplicate Record"
            });
            setTargetData(updatedTargetData)
        }
    }

    const initialgetFields = async () => {
        try {
            if (tmpData.customer === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            setLoading(true);
            var fieldData = await getField(tmpData.customer)
            if ( fieldData && fieldData?.data) {
                var clientModuleData = fieldData.data;
                var targetPlanModules = _.find(clientModuleData.cust[0].modules, { module_name: "Target Plan", status: true });
                var targetPlanFieldsNew = _.find(targetPlanModules.sub_modules, { sub_module_name: "Target Plan" }).fields;
                setTargetPlanFieldsNew(targetPlanFieldsNew);
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false);
        }
    }

    const initialgetTables = async () => {
        try {
            if (tmpData.customer === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            setLoading(true);
            var fieldData = await getTable(tmpData.customer)
            if (fieldData && fieldData?.data) {
                var targetModuleDataTables = fieldData.data;
                var targetFieldsTable = _.find(targetModuleDataTables.cust[0].modules, { module_name: "Target Plan", status: true });
                var targetTable = _.find(targetFieldsTable.sub_modules, { sub_module_name: "Target Plan" }).tables;
                setTargetTable(targetTable);
                var targetHeaders = _.find(targetTable, { table_name: "Target" }).headers;
                setTargetHeaders(targetHeaders);
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false);
        }
    }

    const dynamicMonths = async () => {
        try {
            if (tmpData.customer === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            setLoading(true)
            var customerData = await get(tmpData.customer)
            if (customerData && customerData.data) {
                var month = customerData.data.finance_month;
                var names = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                var res = [];
                for (var i = 0; i < 12; ++i) {
                    res.push(names[month]);
                    if (++month === 12) {
                        month = 0;
                    }
                }
                setMonths(res)
                var referenceData = customerData.data.reference_data;
                setReferenceData(referenceData)
                referenceData.forEach((item) => {
                    if (item.option_names === "logFrameGoal") {
                        setLogFrameGoal(item.option_choice.filter((option) => option.status === 'active'));
                    } else if (item.option_names === "UnitofMeasurement") {
                        setUnitofMeasurement(item.option_choice.filter((option) => option.status === 'active'));
                    }
                });
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false);
        }
    }

    const goalChanges = (index, value) => {
        var tmpOpts = []
        for (var i = 0; i < referenceData.length; i++) {
            var opt = referenceData[i].option_choice.filter(option => option._id === value);
            if (opt.length) {
                var tmpFactor = opt[0].label;
                var tmpOpts = referenceData
                    .find(item => item.display_name === tmpFactor)?.option_choice
                    .filter(option => option.status === 'active');
            }
        }
        setTargetData(prevState =>
            prevState.map((item, i) =>
                i === index
                    ? { ...item, logFrameGoal: value, logFrameTargetOptions: tmpOpts }
                    : item
            )
        );
    }

    const targetChange = (index, value) => {
        var tmpOpts = []
        for (var i = 0; i < referenceData.length; i++) {
            var opt = referenceData[i].option_choice.filter(option => option._id === value);
            if (opt.length) {
                var tmpFactor = opt[0].label;
                var tmpOpts = referenceData
                    .find(item => item.display_name === tmpFactor)?.option_choice
                    .filter(option => option.status === 'active');
            }
        }
        setTargetData(prevState =>
            prevState.map((item, i) =>
                i === index
                    ? { ...item, logFrameTarget: value, logFrameIndicatorOptions: tmpOpts }
                    : item
            )
        );
    }

    const indicatorChange = (index, value) => {
        var tmpOpts = []
        for (var i = 0; i < referenceData.length; i++) {
            var opt = referenceData[i].option_choice.filter(option => option._id === value);
            if (opt.length) {
                var tmpFactor = opt[0].label;
                var tmpOpts = referenceData
                    .find(item => item.display_name === tmpFactor)?.option_choice
                    .filter(option => option.status === 'active');
            }
        }
        setTargetData(prevState =>
            prevState.map((item, i) =>
                i === index
                    ? { ...item, logFrameIndicator: value, logFrameSubIndicatorOptions: tmpOpts }
                    : item
            )
        );
    }

    const yearInc = (limit) => {
        for (var i = 1; i <= limit; i++) {
            var lastVal = years[years.length - 1];
            var strVal = (lastVal.year + 1).toString();
            years.push({ label: strVal, year: lastVal.year + 1 });
            setYears(years)
        }
    }

    const loadByYear = async (year) => {
        try {
            if (tmpData.customer === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            setLoading(true)
            var entity = [];
            var targetData = await getByYear(tmpData.customer, year)
            if (targetData && targetData.data) {
                var af = year < yearDate ? 'Actual' : 'Forecast';
                setHeaderFName(af)
                if (targetData.data && targetData.data.length > 0) {
                    var entity = targetData.data[0].impact_target;
                    setTargetData(entity)
                    setLoadRefresh(true)
                    var totalValue = targetData.data[0].total;
                    setTotalValue(totalValue)
                } else {
                    setTargetData([])
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false);
        }
    };

    const captureChange = (selectedYear) => {
        loadByYear(selectedYear.year);
        setCurrentYear(selectedYear)
    }

    const generateRandomID = () => {
        const hexChars = '0123456789abcdef';
        let result = '';
        for (let i = 0; i < 24; i++) {
            result += hexChars.charAt(Math.floor(Math.random() * hexChars.length));
        }
        return result;
    }

    const addNew = () => {
        const newRow = {
            _id: generateRandomID(),
            logFrameGoal: "",
            logFrameTarget: "",
            logFrameIndicator: "",
            logFrameSubIndicator: "",
            unitOfMeasurement: "",
            logFrame: {
                month1: "",
                month2: "",
                month3: "",
                month4: "",
                month5: "",
                month6: "",
                month7: "",
                month8: "",
                month9: "",
                month10: "",
                month11: "",
                month12: ""
            }
        };
        setTargetData(prevState => ([
            ...prevState,
            newRow
        ]));
    }

    const deleteSelected = () => {
        var selectedId = ''
        targetData.forEach((action) => {
            if (action?.checked) {
                selectedId = action._id
            }
        });

        setTargetData(prevState =>
            prevState.filter(row => row._id !== selectedId)
        );
    }

    const selectedElement = (position, e, entities) => {
        const updatedEntities = entities.map((item, index) => {
            if (position !== index) {
                return {
                    ...item, checked: false
                };
            } else {
                return {
                    ...item, checked: e
                };
            }
        });
        setTargetData(updatedEntities);
    };

    const getMonthsTotal = (selector) => {
        var selectedEntity = targetData[selector];
        var v1 = 0; var v2 = 0; var v3 = 0; var v4 = 0; var v5 = 0; var v6 = 0; var v7 = 0; var v8 = 0; var v9 = 0; var v10 = 0; var v11 = 0; var v12 = 0;
        if (selectedEntity.logFrame) {
            v1 = (selectedEntity.logFrame.month1) ? selectedEntity.logFrame.month1 : 0;
            v2 = (selectedEntity.logFrame.month2) ? selectedEntity.logFrame.month2 : 0;
            v3 = (selectedEntity.logFrame.month3) ? selectedEntity.logFrame.month3 : 0;
            v4 = (selectedEntity.logFrame.month4) ? selectedEntity.logFrame.month4 : 0;
            v5 = (selectedEntity.logFrame.month5) ? selectedEntity.logFrame.month5 : 0;
            v6 = (selectedEntity.logFrame.month6) ? selectedEntity.logFrame.month6 : 0;
            v7 = (selectedEntity.logFrame.month7) ? selectedEntity.logFrame.month7 : 0;
            v8 = (selectedEntity.logFrame.month8) ? selectedEntity.logFrame.month8 : 0;
            v9 = (selectedEntity.logFrame.month9) ? selectedEntity.logFrame.month9 : 0;
            v10 = (selectedEntity.logFrame.month10) ? selectedEntity.logFrame.month10 : 0;
            v11 = (selectedEntity.logFrame.month11) ? selectedEntity.logFrame.month11 : 0;
            v12 = (selectedEntity.logFrame.month12) ? selectedEntity.logFrame.month12 : 0;
        }
        var coltotal = parseFloat(v1) + parseFloat(v2) + parseFloat(v3) + parseFloat(v4) + parseFloat(v5) + parseFloat(v6) + parseFloat(v7) + parseFloat(v8) + parseFloat(v9) + parseFloat(v10) + parseFloat(v11) + parseFloat(v12);
        return coltotal.toFixed(2);
    }

    const loadAndSaving = (targetDetails) => {
        for (var i = 0; i < targetDetails.length; i++) {
            if (targetDetails[i].logFrameGoal) {
                goalChanges(i, targetDetails[i].logFrameGoal);
            }
            if (targetDetails[i].logFrameTarget) {
                targetChange(i, targetDetails[i].logFrameTarget);
            }
            if (targetDetails[i].logFrameIndicator) {
                indicatorChange(i, targetDetails[i].logFrameIndicator);
            }
        }
    }

    const saveTargetUpdate = async () => {
        try {
            if (tmpData.customer === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            setLoading(true)
            var inavalidRecords = [];
            var validRecords = [];
            targetData.filter(function (row) {
                if (row.logFrameGoal == undefined && row.logFrameTarget == undefined && row.logFrameIndicator == undefined && row.logFrameSubIndicator == undefined) {
                    inavalidRecords.push(row);
                }
            });
            targetData.filter(function (row) {
                if (row.logFrameGoal == undefined && row.logFrameTarget == undefined && row.logFrameIndicator == undefined && row.logFrameSubIndicator == undefined) {
                    validRecords.push(row);
                }
            });
            inavalidRecords.filter(function (record) {
                _.remove(targetData, record);
            });

            var targetDetails = {};
            targetDetails.year = currentYear.year;
            targetDetails.customer_id = tmpData.customer;
            targetDetails.impact_target = targetData;
            targetDetails.total = totalValue;
            var targetSave = await saveUpdate(tmpData.customer, targetDetails)
            if (targetSave.data) {
                if (targetSave.data.success) {
                    toastRef.current.showToast({
                        type: 'success',
                        message: "Target Info Updated Successfully"
                    });
                    loadByYear(currentYear.year)
                } else {
                    toastRef.current.showToast({
                        type: 'error',
                        message: "Selected year not available"
                    });
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false);
        }
    }

    const handleButtonClick = () => {
        setShowVideo(true);
    };

    const closeVideo = () => {
        setShowVideo(false);
    };

    return (
        <div className="mt-20">
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div className="form-group row align-items-center mb-0">
                <div className="col-md-10 pl-0">
                    {
                        _.find(targetPlanFieldsNew, { field_name: "Year" })?.field_status &&
                        <div className="form-group row align-items-center mb-0 mt-0 w-30">
                            <div className="col-md-6 pl-0">
                                <label className="form-label text-left">{_.find(targetPlanFieldsNew, { field_name: "Year" })?.display_name}</label>
                            </div>
                            <div className="col pr-0">
                                <DropdownElement
                                    value={currentYear}
                                    onChange={(e) => captureChange(e.value)}
                                    options={(years != undefined && years.length > 0) ? years : []}
                                    optionLabel="label"
                                    placeholder="-- Please select --"
                                    className="w-full"
                                />
                            </div>
                        </div>
                    }
                </div>
                <div className="col pr-0 d-flex justify-end">
                    {
                        _.find(targetTable, { table_name: "Target" })?.status &&
                        <>
                            <ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={deleteSelected} />
                            <ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={addNew} />
                            <ButtonElement className="upload-button ml-10" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
                        </>
                    }
                </div>
            </div>
            {
                _.find(targetTable, { table_name: "Target" })?.status &&
                <>
                    <div className="group-table-data mt-10 risks-tab">
                        <table className="group-datatable activity budget-plan">
                            <thead className="group-table-header">
                                <tr>
                                    <th colSpan={19}>{headerFName + ' - ' + _.find(targetTable, { table_name: "Target" })?.display_name}</th>
                                </tr>
                                <tr>
                                    <th className="checkbox-header width-2"></th>
                                    <th className="width-6">{_.find(targetHeaders, { header_name: "Goal" })?.display_name}</th>
                                    <th className="width-6">{_.find(targetHeaders, { header_name: "Target" })?.display_name}</th>
                                    <th className="width-7">{_.find(targetHeaders, { header_name: "Indicator" })?.display_name}</th>
                                    <th className="width-7">{_.find(targetHeaders, { header_name: "Sub Indicator" })?.display_name}</th>
                                    <th className="width-7">{_.find(targetHeaders, { header_name: "Unit of Measurement" })?.display_name}</th>
                                    <th className="width-5">{months[0]}</th>
                                    <th className="width-5">{months[1]}</th>
                                    <th className="width-5">{months[2]}</th>
                                    <th className="width-5">{months[3]}</th>
                                    <th className="width-5">{months[4]}</th>
                                    <th className="width-5">{months[5]}</th>
                                    <th className="width-5">{months[6]}</th>
                                    <th className="width-5">{months[7]}</th>
                                    <th className="width-5">{months[8]}</th>
                                    <th className="width-5">{months[9]}</th>
                                    <th className="width-5">{months[10]}</th>
                                    <th className="width-5">{months[11]}</th>
                                    <th>{_.find(targetHeaders, { header_name: "Total" })?.display_name}</th>
                                </tr>
                            </thead>
                            <tbody className="group-table-row">
                                {
                                    targetData.length > 0 && targetData?.map((item, index) => {
                                        const logframe_goal = item.logFrameGoal;
                                        const matched = logFrameGoal.find((item) => item._id === logframe_goal);

                                        const logframe_target = item.logFrameTarget;
                                        const matched1 = item.logFrameTargetOptions != undefined ? item.logFrameTargetOptions.find((item) => item._id === logframe_target) : [];

                                        const logFrame_indicator = item.logFrameIndicator;
                                        const matched2 = item.logFrameIndicatorOptions != undefined ? item.logFrameIndicatorOptions.find((item) => item._id === logFrame_indicator) : [];

                                        const logFrame_subIndicator = item.logFrameSubIndicator;
                                        const matched3 = item.logFrameSubIndicatorOptions != undefined ? item.logFrameSubIndicatorOptions.find((item) => item._id === logFrame_subIndicator) : [];

                                        const unit_measurement = item.unitOfMeasurement;
                                        const matched4 = unitofMeasurement.find((item) => item._id === unit_measurement);
                                        return (
                                            <React.Fragment>
                                                <tr>
                                                    <td className="width-2">
                                                        <CheckboxElement
                                                            id={`plan-${index}`}
                                                            name={`plan-${index}`}
                                                            checked={item.checked}
                                                            onChangeCheck={(e) => { selectedElement(index, e.target.checked, targetData) }}
                                                            className="mr-2"
                                                        />
                                                    </td>
                                                    <td className="width-6">
                                                        <DropdownElement
                                                            value={matched ? matched : null}
                                                            onChange={(e) => {
                                                                goalChanges(index, e.value._id)
                                                            }}
                                                            options={(logFrameGoal != undefined && logFrameGoal.length > 0) ? logFrameGoal : []}
                                                            optionLabel="label"
                                                            placeholder="-- Please select --"
                                                            className="w-150"
                                                        />
                                                    </td>
                                                    <td className="width-6">
                                                        <DropdownElement
                                                            value={matched1 ? matched1 : null}
                                                            onChange={(e) => {
                                                                targetChange(index, e.value._id)
                                                            }}
                                                            options={(item.logFrameTargetOptions != undefined && item.logFrameTargetOptions.length > 0) ? item.logFrameTargetOptions : []}
                                                            optionLabel="label"
                                                            placeholder="-- Please select --"
                                                            className="w-150"
                                                        />
                                                    </td>
                                                    <td className="width-7">
                                                        <DropdownElement
                                                            value={matched2 ? matched2 : null}
                                                            onChange={(e) => {
                                                                indicatorChange(index, e.value._id)
                                                            }}
                                                            options={(item.logFrameIndicatorOptions != undefined && item.logFrameIndicatorOptions.length > 0) ? item.logFrameIndicatorOptions : []}
                                                            optionLabel="label"
                                                            placeholder="-- Please select --"
                                                            className="w-150"
                                                        />
                                                    </td>
                                                    <td className="width-7">
                                                        <DropdownElement
                                                            value={matched3 ? matched3 : null}
                                                            onChange={(e) => {
                                                                setTargetData(prevState =>
                                                                    prevState.map((item, i) =>
                                                                        i === index
                                                                            ? { ...item, logFrameSubIndicator: e.value._id }
                                                                            : item
                                                                    )
                                                                );
                                                                setCheckDups({
                                                                    field: true,
                                                                    index: index
                                                                })
                                                            }}
                                                            options={(item.logFrameSubIndicatorOptions != undefined && item.logFrameSubIndicatorOptions.length > 0) ? item.logFrameSubIndicatorOptions : []}
                                                            optionLabel="label"
                                                            placeholder="-- Please select --"
                                                            className="w-150"
                                                        />
                                                    </td>
                                                    <td className="width-7">
                                                        <DropdownElement
                                                            value={matched4 ? matched4 : null}
                                                            onChange={(e) => {
                                                                setTargetData(prevState =>
                                                                    prevState.map((item, i) =>
                                                                        i === index
                                                                            ? { ...item, unitOfMeasurement: e.value._id }
                                                                            : item
                                                                    )
                                                                );
                                                            }}
                                                            options={(unitofMeasurement != undefined && unitofMeasurement.length > 0) ? unitofMeasurement : []}
                                                            optionLabel="label"
                                                            placeholder="-- Please select --"
                                                            className="w-150"
                                                        />
                                                    </td>
                                                    <td className="width-5">
                                                        <InputTextElementElement
                                                            className="dropdown-field-handle"
                                                            value={item.logFrame.month1}
                                                            placeholder=""
                                                            onChange={(e) => {
                                                                setTargetData(prevState =>
                                                                    prevState.map((item, i) =>
                                                                        i === index
                                                                            ? {
                                                                                ...item, logFrame: {
                                                                                    ...item.logFrame,
                                                                                    month1: e.target.value
                                                                                }
                                                                            }
                                                                            : item
                                                                    )
                                                                );
                                                            }}
                                                        />
                                                    </td>
                                                    <td className="width-5">
                                                        <InputTextElementElement
                                                            className="dropdown-field-handle"
                                                            value={item.logFrame.month2}
                                                            placeholder=""
                                                            onChange={(e) => {
                                                                setTargetData(prevState =>
                                                                    prevState.map((item, i) =>
                                                                        i === index
                                                                            ? {
                                                                                ...item, logFrame: {
                                                                                    ...item.logFrame,
                                                                                    month2: e.target.value
                                                                                }
                                                                            }
                                                                            : item
                                                                    )
                                                                );
                                                            }}
                                                        />
                                                    </td>
                                                    <td className="width-5">
                                                        <InputTextElementElement
                                                            className="dropdown-field-handle"
                                                            value={item.logFrame.month3}
                                                            placeholder=""
                                                            onChange={(e) => {
                                                                setTargetData(prevState =>
                                                                    prevState.map((item, i) =>
                                                                        i === index
                                                                            ? {
                                                                                ...item, logFrame: {
                                                                                    ...item.logFrame,
                                                                                    month3: e.target.value
                                                                                }
                                                                            }
                                                                            : item
                                                                    )
                                                                );
                                                            }}
                                                        />
                                                    </td>
                                                    <td className="width-5">
                                                        <InputTextElementElement
                                                            className="dropdown-field-handle"
                                                            value={item.logFrame.month4}
                                                            placeholder=""
                                                            onChange={(e) => {
                                                                setTargetData(prevState =>
                                                                    prevState.map((item, i) =>
                                                                        i === index
                                                                            ? {
                                                                                ...item, logFrame: {
                                                                                    ...item.logFrame,
                                                                                    month4: e.target.value
                                                                                }
                                                                            }
                                                                            : item
                                                                    )
                                                                );
                                                            }}
                                                        />
                                                    </td>
                                                    <td className="width-5">
                                                        <InputTextElementElement
                                                            className="dropdown-field-handle"
                                                            value={item.logFrame.month5}
                                                            placeholder=""
                                                            onChange={(e) => {
                                                                setTargetData(prevState =>
                                                                    prevState.map((item, i) =>
                                                                        i === index
                                                                            ? {
                                                                                ...item, logFrame: {
                                                                                    ...item.logFrame,
                                                                                    month5: e.target.value
                                                                                }
                                                                            }
                                                                            : item
                                                                    )
                                                                );
                                                            }}
                                                        />
                                                    </td>
                                                    <td className="width-5">
                                                        <InputTextElementElement
                                                            className="dropdown-field-handle"
                                                            value={item.logFrame.month6}
                                                            placeholder=""
                                                            onChange={(e) => {
                                                                setTargetData(prevState =>
                                                                    prevState.map((item, i) =>
                                                                        i === index
                                                                            ? {
                                                                                ...item, logFrame: {
                                                                                    ...item.logFrame,
                                                                                    month6: e.target.value
                                                                                }
                                                                            }
                                                                            : item
                                                                    )
                                                                );
                                                            }}
                                                        />
                                                    </td>
                                                    <td className="width-5">
                                                        <InputTextElementElement
                                                            className="dropdown-field-handle"
                                                            value={item.logFrame.month7}
                                                            placeholder=""
                                                            onChange={(e) => {
                                                                setTargetData(prevState =>
                                                                    prevState.map((item, i) =>
                                                                        i === index
                                                                            ? {
                                                                                ...item, logFrame: {
                                                                                    ...item.logFrame,
                                                                                    month7: e.target.value
                                                                                }
                                                                            }
                                                                            : item
                                                                    )
                                                                );
                                                            }}
                                                        />
                                                    </td>
                                                    <td className="width-5">
                                                        <InputTextElementElement
                                                            className="dropdown-field-handle"
                                                            value={item.logFrame.month8}
                                                            placeholder=""
                                                            onChange={(e) => {
                                                                setTargetData(prevState =>
                                                                    prevState.map((item, i) =>
                                                                        i === index
                                                                            ? {
                                                                                ...item, logFrame: {
                                                                                    ...item.logFrame,
                                                                                    month8: e.target.value
                                                                                }
                                                                            }
                                                                            : item
                                                                    )
                                                                );
                                                            }}
                                                        />
                                                    </td>
                                                    <td className="width-5">
                                                        <InputTextElementElement
                                                            className="dropdown-field-handle"
                                                            value={item.logFrame.month9}
                                                            placeholder=""
                                                            onChange={(e) => {
                                                                setTargetData(prevState =>
                                                                    prevState.map((item, i) =>
                                                                        i === index
                                                                            ? {
                                                                                ...item, logFrame: {
                                                                                    ...item.logFrame,
                                                                                    month9: e.target.value
                                                                                }
                                                                            }
                                                                            : item
                                                                    )
                                                                );
                                                            }}
                                                        />
                                                    </td>
                                                    <td className="width-5">
                                                        <InputTextElementElement
                                                            className="dropdown-field-handle"
                                                            value={item.logFrame.month10}
                                                            placeholder=""
                                                            onChange={(e) => {
                                                                setTargetData(prevState =>
                                                                    prevState.map((item, i) =>
                                                                        i === index
                                                                            ? {
                                                                                ...item, logFrame: {
                                                                                    ...item.logFrame,
                                                                                    month10: e.target.value
                                                                                }
                                                                            }
                                                                            : item
                                                                    )
                                                                );
                                                            }}
                                                        />
                                                    </td>
                                                    <td className="width-5">
                                                        <InputTextElementElement
                                                            className="dropdown-field-handle"
                                                            value={item.logFrame.month11}
                                                            placeholder=""
                                                            onChange={(e) => {
                                                                setTargetData(prevState =>
                                                                    prevState.map((item, i) =>
                                                                        i === index
                                                                            ? {
                                                                                ...item, logFrame: {
                                                                                    ...item.logFrame,
                                                                                    month11: e.target.value
                                                                                }
                                                                            }
                                                                            : item
                                                                    )
                                                                );
                                                            }}
                                                        />
                                                    </td>
                                                    <td className="width-5">
                                                        <InputTextElementElement
                                                            className="dropdown-field-handle"
                                                            value={item.logFrame.month12}
                                                            placeholder=""
                                                            onChange={(e) => {
                                                                setTargetData(prevState =>
                                                                    prevState.map((item, i) =>
                                                                        i === index
                                                                            ? {
                                                                                ...item, logFrame: {
                                                                                    ...item.logFrame,
                                                                                    month12: e.target.value
                                                                                }
                                                                            }
                                                                            : item
                                                                    )
                                                                );
                                                            }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <label className="form-label text-left">{getMonthsTotal(index)}</label>
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        );
                                    })
                                }
                            </tbody>
                            <thead className="group-table-header">
                                <tr>
                                    <th className="checkbox-header width-2"></th>
                                    <th colSpan={5}>{_.find(targetHeaders, { header_name: "Monthly Total" })?.display_name}</th>
                                    <th className="width-5">{colTotals[1]}</th>
                                    <th className="width-5">{colTotals[2]}</th>
                                    <th className="width-5">{colTotals[3]}</th>
                                    <th className="width-5">{colTotals[4]}</th>
                                    <th className="width-5">{colTotals[5]}</th>
                                    <th className="width-5">{colTotals[6]}</th>
                                    <th className="width-5">{colTotals[7]}</th>
                                    <th className="width-5">{colTotals[8]}</th>
                                    <th className="width-5">{colTotals[9]}</th>
                                    <th className="width-5">{colTotals[10]}</th>
                                    <th className="width-5">{colTotals[11]}</th>
                                    <th className="width-5">{colTotals[12]}</th>
                                    <th>{totalSales}</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div className="col pr-0 d-flex justify-end">
                        <ButtonElement className="save-button" type="submit" onClick={saveTargetUpdate} label="Save" />
                    </div>
                </>
            }
            <Dialog id="videoModal" visible={showVideo}
                breakpoints={{
                    '1200px': '80vw',    // Larger modal on bigger screens
                    '1024px': '85vw',    // Slightly smaller for medium screens
                    '769': '90vw',     // Responsive on tablets
                    '641px': '95vw',     // Almost full-width on mobile
                }}
                modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
            >
                <div className="video-overlay">
                    <div className="video-container">
                        <PlaylistVideos playlistId={process.env.REACT_APP_MAIN_MODULES_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="target_plan" />
                    </div>
                </div>
            </Dialog>
        </div>
    );
}

export default Baseline